import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api, fileUrl } from "@/lib/api";
import { ArrowLeft } from "lucide-react";
import RichTextView from "@/components/app/RichTextView";
import AttachmentList from "@/components/app/AttachmentList";

export default function NewsDetail() {
  const { id } = useParams();
  const [item, setItem] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    api.get(`/news/${id}`).then((r) => setItem(r.data)).catch(() => setError("Not found"));
  }, [id]);

  if (error) return <div className="mx-auto max-w-3xl px-4 py-20 text-center text-stone-600">Article not found.</div>;
  if (!item) return <div className="mx-auto max-w-3xl px-4 py-20 text-center text-stone-500">Loading…</div>;

  const attachments = item.attachments || [];
  const firstImage = attachments.find((a) => (a.content_type || "").startsWith("image/"));
  const docs = attachments.filter((a) => !(a.content_type || "").startsWith("image/"));

  return (
    <div className="mx-auto max-w-3xl px-4 py-10 sm:px-6 lg:px-8">
      <Link to="/news" className="inline-flex items-center gap-1 text-sm text-stone-600 hover:text-stone-900">
        <ArrowLeft className="h-4 w-4" /> Back to news
      </Link>
      <article className="mt-6 rounded-3xl border border-stone-200 bg-white p-6 sm:p-10 shadow-sm">
        <div className="text-xs font-mono uppercase tracking-widest text-[#c85a32]">
          {item.date ? new Date(item.date).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" }) : ""}
        </div>
        <h1 className="mt-2 font-serif text-4xl font-semibold text-stone-900">{item.headline}</h1>
        {firstImage && (
          <img
            src={fileUrl(firstImage.file_id)}
            alt={firstImage.filename || ""}
            className="mt-6 w-full rounded-2xl object-cover"
          />
        )}
        <RichTextView html={item.body} className="mt-6 text-lg" />
        {docs.length > 0 && (
          <div className="mt-8" data-testid="news-attachments">
            <AttachmentList attachments={docs} testidPrefix="news-attachment" />
          </div>
        )}
      </article>
    </div>
  );
}
